export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "吃瓜速递多久更新一次内容？",
    a: "本站每日持续更新，聚焦近期热门吃瓜事件与八卦汇总。想看点最新热点事件，收藏本站每天刷新首页与事件库即可看到最新更新的视频内容与事件脉络。",
  },
  {
    q: "你们的内容覆盖哪些栏目？",
    a: "我们覆盖明星动态、娱乐八卦、综艺现场、网络红人与社会热点五大栏目，同时提供今日热搜榜、最新热点和精选专题，帮助你快速掌握不同领域的吃瓜动态。",
  },
  {
    q: "如何找到某个热点事件的完整视频汇总？",
    a: "你可以进入事件库按栏目分类浏览，也可以使用首页搜索框输入关键词查找。每个事件详情页都汇聚了该话题下的多条视频与事件完整脉络，方便一次性吃透。",
  },
  {
    q: "吃瓜速递适合什么类型的用户？",
    a: "适合所有关注娱乐八卦、明星动态和全网热门事件的网友。无论你是想看最新热点、追某个事件的后续，还是想快速回顾近期八卦汇总，本站都能满足需求。",
  },
  {
    q: "网站的访问是否需要注册或付费？",
    a: "完全免费，无需注册登录即可浏览全部内容。我们提供纯净的浏览体验，只专注做靠谱的热点视频汇总与速递。",
  },
  {
    q: "如何反馈想要收录的热点事件？",
    a: "如果你有想看的吃瓜事件或发现遗漏的热门话题，欢迎通过关于我们页面提供的联系方式向我们反馈，我们会评估后尽快补充更新。",
  },
];